class CustomCountdownDays extends HTMLElement {
  constructor() {
    super();
    this.days = this.getAttribute("data-days")*1 || 0
    this.first_time_node = this.getAttribute("data-first-node") || "0"
    this.end_time_node = this.getAttribute("data-end-node") || "0"
    this.now_time = this.getAttribute("data-now") || new Date()
  }
   connectedCallback() {
    this.updateCountdown();
  }
  updateCountdown(){
        let now = Date.parse(this.now_time)
        var first_end = false
        var end_time = false
        var time_end = false
        if (this.first_time_node && this.first_time_node !== "0") {
            first_end = this.parseDate(this.first_time_node);
        }
        
        if (this.end_time_node && this.end_time_node !== "0") {
          end_time = this.parseDate(this.end_time_node);
          if (end_time <= now) time_end = true;
        }
        
      let end = null
      if (time_end) {
        if (this.timer) clearInterval(this.timer);
          this.closest(".product-time-limit--countdown").style.display = "none"
          return; 
      }

      if (this.days > 0) {
        if (first_end  && first_end > now) {
            end = first_end
        }else if (first_end) {
            end = new Date(first_end);
            while (end <= now) {
              end.setDate(end.getDate() + this.days);
              if (end >= end_time) {
              end = end_time
                  break; 
              }
            }
        }
      }else{
        end = end_time
      }
        if (!end || isNaN(end.getTime())) {
          this.textContent = "Invalid date";
          return;
        }
        console.log(end);
        
        let end_parse = Date.parse(end)
        console.log(end_parse);
        
        let time = end - now
        let x = setInterval(() => {
            time = time-1000
            let time_obj = this.get_compare_time(time)
            this.querySelector(".days").innerHTML = time_obj.DD
            this.querySelector(".hours").innerHTML = time_obj.HH
            this.querySelector(".minutes").innerHTML = time_obj.MM
            this.querySelector(".seconds").innerHTML = time_obj.SS
            if (time <= 0) {
                this.closest(".product-time-limit--countdown").style.display = "none"
                clearInterval(x);
                return
            }
        }, 1000)
        
  }
  parseDate(str) {
    if (!str || str === "0") return null;
    const parts = str.split("-").map(Number);
    const [y, m, d, h = 0, min = 0, s = 0] = parts;
    return new Date(y, m - 1, d, h, min, s);
  }
  get_compare_time(time) {
        let days = Math.floor(time / (1000 * 60 * 60 * 24));
        let hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((time % (1000 * 60)) / 1000);
        days = days >= 10 ? days : "0" + days
        hours = hours >= 10 ? hours : "0" + hours
        minutes = minutes >= 10 ? minutes : "0" + minutes
        seconds = seconds >= 10 ? seconds : "0" + seconds

      return {
          DD: days,
          HH: hours,
          MM: minutes,
          SS: seconds
      }
  }
 
}

customElements.define('custom-countdown-days', CustomCountdownDays);


// product-video
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-product-videos').forEach(function(section){

    const productSwiperEl = section.querySelector('.custom-product-videos-swiper');
    const popup = document.querySelector('.popup-' + section.id.replace('product-video-',''));
    const popupSwiperEl = popup.querySelector('.popup_swiper_cards');

    const productSwiper = new Swiper(productSwiperEl, {
      slidesPerView: "auto",
      spaceBetween: 12,
      freeMode: true,
      breakpoints: {
        0: {
          spaceBetween: 12
        },
        750: {
          spaceBetween: 14
        }
      }
    });

    const popupSwiper = new Swiper(popupSwiperEl, {
      effect: "cards",
      grabCursor: true,
      observer: true,
      observeParents: true
    });

    section.querySelectorAll('.custom-product-videos-unit').forEach(function(slide){
      slide.addEventListener('click', function(){
        const index = parseInt(slide.dataset.index);

        popup.style.display = "flex";

        popup.querySelectorAll('video').forEach(v=>v.pause());

        popupSwiper.update();
        popupSwiper.slideTo(index);

        const video = popupSwiper.slides[index].querySelector('video');
        if(video) video.play();
      });
    });

    popupSwiper.on('slideChange', function(){
      popupSwiper.slides.forEach((slide, i)=>{
        const video = slide.querySelector('video');
        if(video){
          if(i === popupSwiper.activeIndex){
            video.play();
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    });

    popup.querySelector('.close_icon').addEventListener('click', function(){
      popup.style.display = "none";
      popup.querySelectorAll('video').forEach(v=>v.pause());
    });

    section.querySelectorAll('.custom-product-videos-unit').forEach(slide=>{
      const video = slide.querySelector('video.my-custom-video-class');
      if(video){
        video.addEventListener('loadedmetadata', function(){
          slide.style.width = video.videoWidth + 'px';
        });
      }
    });
    popupSwiper.slides.forEach(slide=>{
      const video = slide.querySelector('video.popup-video-element');
      if(video){
        video.addEventListener('loadedmetadata', function(){
          slide.style.width = video.videoWidth + 'px';
        });
      }
    });

  });
});
